import { Center, Text } from "@chakra-ui/react";
import { useCallback, useRef, useState } from "react";

const Dropzone = ({ onChange }) => {
  const [dragging, setDragging] = useState(false);
  const fileInputRef = useRef(null);

  const handleDragOver = useCallback((event) => {
    event.preventDefault();
    setDragging(true);
  }, []);

  const handleDragLeave = useCallback(() => {
    setDragging(false);
  }, []);

  const handleFiles = useCallback(
    (files) => {
      onChange(files);
    },
    [onChange]
  );

  const handleDrop = useCallback(
    (event) => {
      event.preventDefault();
      setDragging(false);
      const files = event.dataTransfer.files;
      handleFiles(files);
    },
    [handleFiles]
  );

  const onFileInputChange = (e) => {
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    handleFiles(files);
  };

  const openFileDialog = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <Center
      height="320px"
      borderWidth="2px"
      borderRadius="md"
      borderStyle="dashed"
      borderColor={dragging ? "gray.400" : "gray.500"}
      bg={dragging ? "gray.600" : "gray.800"}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={openFileDialog}
      textAlign="center"
      style={{ transition: "background-color .3s", cursor: "pointer" }}
    >
      <Text>Drag and drop your file here, or click to select a file</Text>
      <input
        ref={fileInputRef}
        type="file"
        hidden
        onChange={onFileInputChange}
        accept="image/jpeg"
      />
    </Center>
  );
};

export default Dropzone;
